var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#8D93AB","fillRule":"evenodd","d":"M4.358 1.865c0 1.036-.744 1.865-1.94 1.865h-.023C1.245 3.73.5 2.901.5 1.865.5.805 1.267 0 2.44 0s1.896.806 1.918 1.865zm-.225 3.34V16H.703V5.204h3.43zM16.5 16V9.81c0-3.316-1.692-4.86-3.948-4.86-1.821 0-2.636 1.048-3.091 1.784v-1.53H6.03C6.075 6.218 6.03 16 6.03 16h3.43V9.97c0-.322.022-.643.112-.875.248-.644.813-1.312 1.76-1.312 1.242 0 1.738.99 1.738 2.441V16H16.5z"}));
}

Linkedin.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
